/* eslint-disable react/no-danger */
import Script from 'next/script'
import React from 'react'

export const scriptContent = `
  const body = document.getElementsByTagName('BODY')[0];
  if(body){
    body.classList.remove('preload');
  }
`

export const PreloadRemover = () => (
  <Script
    key="preload-class"
    dangerouslySetInnerHTML={{ __html: scriptContent }}
    id="preload-class"
    strategy="afterInteractive"
    type="text/javascript"
  />
)
